import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LanguagePickerComponent} from './language-picker.component';
import {TuiDataListWrapperModule, TuiSelectModule} from '@taiga-ui/kit';
import {TuiFlagPipeModule, TuiTextfieldControllerModule} from '@taiga-ui/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@NgModule({
  declarations: [LanguagePickerComponent],
  imports: [
    CommonModule,
    TuiFlagPipeModule,
    FormsModule,
    ReactiveFormsModule,
    TuiSelectModule,
    TuiDataListWrapperModule,
    TuiTextfieldControllerModule,
  ],
  exports: [LanguagePickerComponent],
})
export class LanguagePickerModule {}
